"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeState = computeState;
exports.deriveStateMachineConfig = deriveStateMachineConfig;
exports.getNumStates = getNumStates;
const VMConstants_1 = require("../constants/VMConstants");
const NUM_STATES = 8;
const MIX_MULT1 = 2654435769;
const MIX_MULT2 = 2246822507;
const MIX_MULT3 = 3266489909;
function mixBits(h) {
    h = h >>> 0;
    h ^= h >>> 16;
    h = Math.imul(h, MIX_MULT2) >>> 0;
    h ^= h >>> 13;
    h = Math.imul(h, MIX_MULT3) >>> 0;
    h ^= h >>> 16;
    return h >>> 0;
}
function computeState(seed, pc) {
    const combined = seed ^ ((pc * MIX_MULT1) >>> 0);
    return mixBits(combined) % NUM_STATES;
}
function generatePermutation(seed, size) {
    const arr = [];
    for (let i = 0; i < size; i++) {
        arr[i] = i;
    }
    let s = seed;
    for (let i = size - 1; i > 0; i--) {
        s = mixBits(s ^ i);
        const j = s % (i + 1);
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }
    return arr;
}
function deriveStateMachineConfig(seed, initialState, initialStackKey) {
    const stateMaps = [];
    for (let state = 0; state < NUM_STATES; state++) {
        const stateSeed = mixBits(seed ^ (state * MIX_MULT1));
        const permutation = generatePermutation(stateSeed, VMConstants_1.VM_OPCODE_COUNT);
        const stateMap = {};
        for (let i = 0; i < VMConstants_1.VM_OPCODE_COUNT; i++) {
            stateMap[i] = permutation[i];
        }
        stateMaps.push(stateMap);
    }
    return {
        seed,
        initialState,
        initialStackKey,
        stateMaps
    };
}
function getNumStates() {
    return NUM_STATES;
}
